define('lib/view/mixin/BookingResultPopupMixin',['require','Config'],function (require) {

    var Config = require('Config');

    return {

        isShowBookingResultPopup: function(data){
            if(['new'].indexOf(data.status) > -1){
                return false; //ignore this status
            }
            var bookingIds = data.booking_ids;
            if(!Array.isArray(bookingIds)){
                bookingIds = [bookingIds];
            }
            if(this._isPopupDisplayed(data.status, bookingIds)){
                return false; //popup already closed
            }
            this._setPopupDisplayed(data.status, bookingIds);

            return true;
        },

        isShowInvoicePopup: function(bookingIds, model){
            var status = model.get('status');
            var paymentProcessor = model.get('payment_processor');
            var paymentReceived = model.get('payment_received');

            //console.log(bookingIds,model);

            if(status === 'paid'){
                status = 'success';
            }
            if(paymentProcessor === 'delay' && !paymentReceived){
                status = 'delay';
            }

            if(['new'].indexOf(status) > -1){
                return false; //ignore this status
            }

            if(!Array.isArray(bookingIds)){
                bookingIds = [bookingIds];
            }
            if(this._isPopupDisplayed(status, bookingIds)){
                return false; //popup already closed
            }
            this._setPopupDisplayed(status, bookingIds);

            return true;
        },

        _isLocalStorageAvailable: function () {
            var test = 'test';
            try {
                localStorage.setItem(test, test);
                localStorage.removeItem(test);
                return true;
            } catch(e) {
                return false;
            }
        },

        _isPopupDisplayed: function (status, bookingIds) {
            var statusKey = 'hrp_' + status + '_' + bookingIds.join('_');
            if(window[statusKey]){
                return true; //popup already closed
            }
            if(this._isLocalStorageAvailable() && localStorage.getItem(statusKey)){
                return true;
            }
            return false;
        },

        _setPopupDisplayed: function (status, bookingIds) {
            var statusKey = 'hrp_' + status + '_' + bookingIds.join('_');
            window[statusKey] = true;
            if(this._isLocalStorageAvailable()){
                localStorage.setItem(statusKey, 1);
            }
        },

    };

});

